import React from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  alpha,
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';

const SearchInput = ({
  value,
  onChange,
  onClear,
  placeholder = 'Buscar...',
  fullWidth = false,
  size = 'small',
  sx = {},
  ...props
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    } else {
      onChange({ target: { value: '' } });
    }
  };

  return (
    <TextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      size={size}
      fullWidth={fullWidth}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: 'text.secondary', fontSize: 20 }} />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={handleClear}
              sx={{ 
                padding: 0.5,
                '&:hover': {
                  backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
                },
              }}
            >
              <Clear sx={{ fontSize: 18, color: 'text.secondary' }} />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      sx={{
        minWidth: 200,
        '& .MuiOutlinedInput-root': {
          backgroundColor: (theme) => alpha(theme.palette.grey[100], 0.5),
          '&:hover': {
            backgroundColor: (theme) => alpha(theme.palette.grey[100], 0.8),
          },
          '&.Mui-focused': {
            backgroundColor: 'white',
          },
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default SearchInput;
